import urlJoin from 'url-join'

import { flattenRoutes } from '@aletheia/common/components/Nav'
import { getRedirect } from '@aletheia/common/components/Redirect'

import { routes } from './[...path]'

const firstRoute = flattenRoutes(routes)[0]
const { Redirect, getServerSideProps } = getRedirect(
  urlJoin(`/stats`, firstRoute.as || firstRoute.href),
  true,
)

export { getServerSideProps }

export default Redirect
